import { render, staticRenderFns } from "./workflowCreate.vue?vue&type=template&id=51590520&"
import script from "./workflowCreate.vue?vue&type=script&lang=js&"
export * from "./workflowCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51590520')) {
      api.createRecord('51590520', component.options)
    } else {
      api.reload('51590520', component.options)
    }
    module.hot.accept("./workflowCreate.vue?vue&type=template&id=51590520&", function () {
      api.rerender('51590520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/workflow/workflowCreate/workflowCreate.vue"
export default component.exports